<template>
    <div class="editor_config"
        :class="[showProductData ? 'user_scene' : 'merchant_scene', isTabPanelVisible ? '' : 'noTabPanel']"
        :style="colors"
    >
        <div class="editor_scene">
            <SceneOptions
                :activeEl="activeElement"
            />
            <ScenePages/>
        </div>
        <!-- <ProductData v-if="getSessionDetails.mode === 'user'"></ProductData> -->
        <ProductData v-if="showProductData" />
    </div>
</template>

<script>
    import axios from 'axios'
    import { mapState, mapGetters } from 'vuex';
    import SceneOptions from './SceneOptions.vue';
    import ScenePages from './ScenePages.vue';
    import ProductData from './ProductData.vue';
    import { addFont } from '../../js/customFonts';

    export default {
        data() {
            return {
                customFontsArr: []
            }
        },
        computed: {
            ...mapState([
                'currentPageIndex'
            ]),
            ...mapGetters([
                'getProject',
                'getSessionDetails',
                'getCustomFonts'
            ]),
            showProductData() {
                if (this.getSessionDetails.mode === 'user') {
                    if (this.getSessionDetails.productGatewayEnabled === true ) {
                        return true;
                    } return false;
                } 
                return false;
            },
            activeElement() {
                let hasElements = this.getProject.pages[this.currentPageIndex].content.elements === undefined ? false : true;
                if (hasElements) {
                    let activeElementIndex = this.getProject.pages[this.currentPageIndex].content.elements.findIndex(el => el.isActive);
                    if (!(activeElementIndex < 0)) {
                        return this.getProject.pages[this.currentPageIndex].content.elements[activeElementIndex];
                    } else {
                        return null
                    }
                } else {
                    return null
                }
            },
            isTabPanelVisible() {
                if (this.getSessionDetails.mode === 'user') {
                    let visiblePanels = [];
                    Object.keys(this.getSessionDetails.editorSetup.hiddenTabs).forEach(tab => {
                        if (this.getSessionDetails.editorSetup.hiddenTabs[tab] === false) {
                            visiblePanels.push(tab)
                        }
                    });

                    if (visiblePanels.length > 0) {
                        return true;
                    } return false;
                } else { return true};
            },
            colors() {
                return {
                    '--primary-color': `#${this.getSessionDetails.editorSetup.colors.primaryColor}`
                }
            }
        },
        mounted() {
            this.getCustomFonts.forEach(font => {
                document.head.append(addFont(font.family, font.fontHref, font.weights[0].value, font.weights[0].style));
            });

            this.getCustomFonts.forEach(font => {
                const fontCopy = JSON.parse(JSON.stringify(font));
                const isFontFamilyPresent = this.customFontsArr.findIndex(f => f.family === font.family);

                if (isFontFamilyPresent !== -1) {
                    this.customFontsArr[isFontFamilyPresent].weights.push(...fontCopy.weights)
                } else {
                    this.customFontsArr.push(fontCopy)
                }
            });

            this.customFontsArr.map(font => {
                delete font['fontHref'];
                font.isCustom = true;
            });

            this.$store.dispatch('ADD_FORMATED_CUSTOM_FONTS', this.customFontsArr);

            if (this.getSessionDetails.mode === 'user') {
                window.onpopstate = function(event) {
                    window.top.history.go(-2);
                }
            }
        },
        components: {
            SceneOptions,
            ScenePages,
            ProductData
        }
    }
</script>

<style lang="scss">
    .editor_config {
        width: 75%;
        display: grid;
    }
    .editor_config.noTabPanel {
        width: 100%;
    }
    .user_scene {
        grid-template-columns: 1fr 260px;
    }
    .merchant_scene {
        grid-template-columns: 1fr;
    }
    .editor_scene {
        position: relative;
        box-sizing: border-box;
        padding: 15px;
        overflow: auto;
        // display: grid;
        // grid-template-rows: 42px auto;
    }
    .merchant_scene .pages {
        margin: auto;
    }
    @media (max-width: 1500px) {
        .editor_config {
            width: calc(100% - 300px);
        }
        .editor_config.noTabPanel {
            width: 100%;
        }
        .user_scene {
            grid-template-columns: 1fr 200px;
        }
    }
    @media (max-width: 1200px) {
        .editor_config {
            width: calc(100% - 260px);
        }
        .editor_config.noTabPanel {
            width: 100%;
        }
        // .user_scene {
        //     grid-template-columns: 1fr 200px;
        // }
    }
</style>